import type { ReactNode } from 'react';
import { MenuTrigger, type MenuTriggerProps } from 'react-aria-components';
import { MenuButton } from './menu-button';
import { MenuContent } from './menu-content';
import { MenuItem } from './menu-item';
import { MenuItemDivider } from './menu-item-divider';

function MenuComponent(props: MenuTriggerProps): ReactNode {
  return <MenuTrigger {...props} />;
}

export const Menu = Object.assign(MenuComponent, {
  Button: MenuButton,
  Content: MenuContent,
  Divider: MenuItemDivider,
  Item: MenuItem,
});
